import { NURSES_ACTIONS } from 'constants/Actions/Nurses';

// Estado inicial del reducer
const aInitialState = {
    aNursesSuggestion: [],
    aNurses : [],
    oNurse : null,
    nNewId: null,
    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los/as enfermeros/as del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Matías Rivero 
 */
export const NurseReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case NURSES_ACTIONS.GET:
            return { ...aState, aNurses: oAction.data };
        case NURSES_ACTIONS.FIND:
            return { ...aState, oNurse: oAction.data };
        case NURSES_ACTIONS.SUCCESS:            
            return { ...aState, bIsSuccess: true, nNewId: oAction.data };
        case NURSES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case NURSES_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oNurse: null, nNewId: null };
        case NURSES_ACTIONS.SUGGESTION:
            return { ...aState, aNursesSuggestion: oAction.data };
        case NURSES_ACTIONS.SUGGESTION_CLEAN:
            return { ...aState, aNursesSuggestion: [] };
        default:
            return aState;
    }
}
